import { atom } from "recoil";

export const addStateProdCodetype = atom({
  key: "addStateProdCodetype",
  default: false,
});
export const editStateProdCodetype = atom({
  key: "editStateProdCodetype",
  default: false,
});
export const selectedProdCodetype = atom({
  key: "selectedProdCodetype",
  default: [],
});

export const selectedRowsStateProducerCodeType = atom({
  key: "selectedRowsStateProducerCodeType",
  default: [],
});

export const setFilterTextProducerCodeType = atom({
  key: "setFilterTextProducerCodeType",
  default: "",
});
